import { AppKitNetwork } from "@reown/appkit-common";
import type { InferredCaipNetwork } from "@reown/appkit-common";
import UniversalProvider from "@walletconnect/universal-provider";
import { AppKit, createAppKit } from "@reown/appkit";
import { WIKEY_CHAIN_ID } from "../utils/constants";
import { config } from "../config";

export const projectId = import.meta.env.VITE_PROJECT_ID;

if (!projectId) {
  throw new Error("Project ID is not defined");
}

const omnistar: InferredCaipNetwork = {
  id: WIKEY_CHAIN_ID,
  chainNamespace: "omnistar" as const,
  caipNetworkId: "omnistar:self" as const,
  name: "Wikey",
  nativeCurrency: { name: "OST", symbol: "OST", decimals: 9 },
  rpcUrls: { default: { http: ["https://rpc.omnistar.io"] } },

  blockExplorers: {
    default: {
      name: "Wikey explorer",
      url: "https://explorer.omnistar.io/?lab=mainnet/",
    },
  },
};

export const networks = [omnistar] as [AppKitNetwork, ...AppKitNetwork[]];

let provider: UniversalProvider | undefined;
let providerPromise: Promise<UniversalProvider> | undefined;
let modal: AppKit | undefined;

export async function initializeProvider() {
  // Return existing provider if already initialized
  if (provider) {
    return provider;
  }

  // Return existing promise if initialization is in progress (prevents race condition)
  if (providerPromise) {
    return providerPromise;
  }

  // Start initialization and cache the promise
  providerPromise = UniversalProvider.init({
    projectId,
    metadata: {
      name: "Wikey",
      description: "Wikey Dapp",
      url: import.meta.env.VITE_WALLET_CONNECT_URL,
      icons: [
        "https://cdn.prod.website-files.com/66055632518763f5b68a2c87/6989d89de1d2bd947ac6046d_wikey%20icon1.png",
      ],
    },
  }).then((p) => {
    provider = p;
    return p;
  });

  return providerPromise;
}

export function initializeModal(universalProvider?: UniversalProvider) {
  if (!modal && universalProvider) {
    modal = createAppKit({
      projectId,
      networks,
      universalProvider: universalProvider,
      manualWCControl: true,

      features: {
        analytics: true, // Optional - defaults to your Cloud configuration
        collapseWallets: true,
      },
      termsConditionsUrl: config.termsConditionsUrl,
      privacyPolicyUrl: config.privacyPolicyUrl,

      showWallets: false,
      customWallets: [
        {
          id: "omnistar",
          name: "Wikey",
          mobile_link: config.mobileLinkUrl,
          app_store: config.appStoreUrl,
          play_store: config.playStoreUrl,
          image_url:
            "https://cdn.prod.website-files.com/66055632518763f5b68a2c87/6989d89de1d2bd947ac6046d_wikey%20icon1.png",
        },
      ],
      debug: true,
      allowUnsupportedChain: true,
    });
  }
  return modal;
}
